import React from "react";

import { canUseDOM } from "../lib/env";

const HOVER_THRESHOLD_MS = 1000;
let lastTouchTimestamp = 0;

export function useHoverState() {
  const [isHoverEnabled, setIsHoverEnabled] = React.useState(false);

  const enableHover = React.useCallback(() => {
    if (
      isHoverEnabled ||
      Date.now() - lastTouchTimestamp < HOVER_THRESHOLD_MS
    ) {
      return;
    }

    setIsHoverEnabled(true);
  }, [isHoverEnabled]);

  const disableHover = React.useCallback(() => {
    lastTouchTimestamp = Date.now();
    if (isHoverEnabled) {
      setIsHoverEnabled(false);
    }
  }, [isHoverEnabled]);

  React.useEffect(() => {
    if (!canUseDOM) {
      return;
    }

    document.addEventListener("touchstart", disableHover, true);
    document.addEventListener("touchmove", disableHover, true);
    document.addEventListener("mousemove", enableHover, true);

    return () => {
      document.removeEventListener("touchstart", disableHover, true);
      document.removeEventListener("touchmove", disableHover, true);
      document.removeEventListener("mousemove", enableHover, true);
    };
  }, [disableHover, enableHover]);

  return isHoverEnabled;
}
